export default [
  {
    name: "Man-made Features",
    type: "mms",
    inputType: "slopeno",
    hint: "e.g. 11SW-C/ND 32",
    displayField: "SLOPE_NO",
    itemDetailType: "mms",
  },
  {
    name: "Road / Building / Place",
    type: "freeText",
    hint: "e.g. Canton Road",
    displayField: "DISPLAYFIELD",
  },
  {
    name: "Lot Number",
    type: "freeText",
    hint: "e.g. DD123 Lot123",
    displayField: "DISPLAYFIELD",
  },
  {
    name: "Lamp Post",
    type: "freeText",
    hint: "e.g. AA1234",
    displayField: "DISPLAYFIELD",
  },
  {
    name: "Coordinates",
    type: "coordinate",
    inputType: "coordinate",
  },
  {
    name: "GIU Report",
    type: "gireport",
    itemDetailType: "gireport",
    displayField: "REPNO",
    layerId: 26,
    fields: ["REPNO"],
    searchType: "EXACT",
    resultItemFormatter: (row) =>
      row.REPNO !== "DUMMY_CELL" && (
        <div>
          Report No. : {row.REPNO} <br />
          Title : {row.TITLE} <br />
          Type : {row.REPTYPE} <br />
          Author : {row.AUTHOR} <br />
          Works No. : {row.WORKNO} <br />
          Contract No. : {row.CONTRACT}
        </div>
      ),
    customIdentifyExportFormat: (sb, mData, CustomSearch) => {
      if (!CustomSearch) sb.push("REPORT_NO,TITLE,TYPE,AUTHOR,WORKNO,CONTRACT");

      for (var i = 0; i < mData.length; i++) {
        let newAttr = {};
        Object.keys(mData[i].attributes).forEach((j) => {
          let newKey = j.substring(j.lastIndexOf(".") + 1);
          newAttr[newKey] = mData[i].attributes[j];
        });
        var mGraphic = { attributes: newAttr };
        var mREPORT_NO = mGraphic.attributes.REPNO;
        var mTITLE = mGraphic.attributes.TITLE;
        var mTYPE = mGraphic.attributes.REPTYPE;
        var mAUTHOR = mGraphic.attributes.AUTHOR;
        var mWORKNO = mGraphic.attributes.WORKNO;
        var mCONTRACT = mGraphic.attributes.CONTRACT;

        if (mREPORT_NO === "DUMMY_CELL") continue;

        sb.push(
          mREPORT_NO +
            ',"' +
            mTITLE +
            '",' +
            mTYPE +
            ',"' +
            mAUTHOR +
            '","' +
            mWORKNO +
            '","' +
            mCONTRACT +
            '"'
        );
      }
    },
  },
  {
    name: "UAV",
    type: "uav",
    inputType: "uav",
    is3DOnly: true,
    displayField: "key",
  },
  {
    name: "Active Sites - Civil Engineering Projects",
    type: "textualSearchLayer",
    layerId: 7,
    fields: ["CONT_NO"],
    searchType: "LIKE",
  },
  {
    name: "Active Sites - Districts",
    type: "textualSearchLayer",
    layerId: 6,
    searchExample: "File Ref.",
    searchType: "LIKE",
    fields: ["PROJECT_RE", "ERKS_REF"],
    searchExample2: "Project ID",
    fields2: ["PROJECTID"],
    searchType2: "EXACT",
    isNumberFields2: true,
  },
  {
    name: "Active Sites - LPM",
    type: "textualSearchLayer",
    inputType: "slopeno",
    layerId: 8,
    fields: ["SLOPE_NO"],
    searchType: "EXACT",
  },
  {
    name: "Blasting Sites",
    type: "textualSearchLayer",
    layerId: 9,
    fields: ["SITECODE"],
    searchType: "LIKE",
  },
  {
    name: "Boulder",
    type: "textualSearchLayer",
    layerId: 10,
    fields: ["KEY"],
    displayField: "KEY",
    searchType: "LIKE",
  },
  {
    name: "CEDD - TGLA",
    type: "textualSearchLayer",
    layerId: 11,
    fields: ["Site_ID"],
    displayField: "Site_ID",
    searchType: "LIKE",
  },
  {
    name: "DADS",
    type: "textualSearchLayer",
    layerId: [12, 13, 14, 15, 45],
    fields: ["REF", "REF", "DH_ORDER", "AL_REF", "REF"],
    searchType: "LIKE",
    searchExample: (
      <span>
        DH File (e.g. DH003/01/HK)
        <br />
        DH Case (e.g. ME0281)
        <br />
        DH Order (e.g. DH025/K /98/C)
        <br />
        Advisory Letter Case (e.g. A-ME0107)
        <br />
        Advisory Letter Type (e.g. LME00063)
      </span>
    ),
  },
  {
    name: "Development Projects",
    type: "textualSearchLayer",
    layerId: [18, 19, 20],
    fields: ["TAGMARK", "REF", "REF"],
    searchType: "LIKE",
  },
  {
    name: "ENTLI",
    type: "textualSearchLayer",
    inputType: "slopeno",
    slopePart3List: [],
    noSlopeTextbox: true,
    layerId: [21, 22],
    fields: ["ENTLI_NO", "ENTLI_NO"],
    displayField: "ENTLI_NO",
    searchType: "LIKE",
  },
  {
    name: "Feature Status Review / Slope Checking Status",
    type: "textualSearchLayer",
    layerId: [23, 24],
    fields: ["SCS_ID", "SCS_ID"],
    searchType: "LIKE",
    searchExample: (
      <span>
        Feature Status Review (e.g. 7024_1_1)
        <br />
        Slope Checking Status (e.g. SCS_5958)
      </span>
    ),
  },
  {
    name: "GCC Cases",
    type: "textualSearchLayer",
    layerId: 25,
    fields: ["REF"],
    searchType: "LIKE",
  },
  {
    name: "Hillside Pocket",
    type: "textualSearchLayer",
    inputType: "slopeno",
    slopePart3List: ["HP"],
    slopePart4InputType: "text",
    layerId: 41,
    fields: ["HP_NO"],
    searchType: "EXACT",
  },
  {
    name: "Historical Landslide Catchment (2016)",
    type: "textualSearchLayer",
    inputType: "slopeno",
    slopePart3List: ["DF", "OH"],
    layerId: 27,
    fields: ["CATCH_NO"],
    displayField: "CATCH_NO",
    searchType: "EXACT",
  },
  {
    name: "Incidents (Confirmed / To be confirmed)",
    type: "textualSearchLayer",
    layerId: [28, 29],
    fields: ["INCID", "INCIDENT"],
    searchType: "LIKE",
  },
  {
    name: "Issued DBEL",
    type: "textualSearchLayer",
    layerId: 46,
    fields: ["DBEL_NO_"],
    searchType: "LIKE",
  },
  {
    name: "Land Matter",
    type: "textualSearchLayer",
    layerId: 31,
    fields: ["REF"],
    searchType: "LIKE",
  },
  {
    name: "Landslide Studies Report Areas",
    type: "textualSearchLayer",
    layerId: 32,
    fields: ["TAGMARK"],
    searchType: "LIKE",
  },
  {
    name: "LPM Stage 2(H) Study",
    type: "textualSearchLayer",
    inputType: "slopeno",
    slopePart3List: ["SA", "HPSA"],
    slopePart4InputType: "text",
    layerId: 34,
    fields: ["1NE-A/SA1"],
    searchType: "TEXT",
  },
  {
    name: "LPM Stage 3(H) Study",
    type: "textualSearchLayer",
    inputType: "slopeno",
    slopePart3List: ["DF", "OH", "HP"],
    slopePart4InputType: "text",
    layerId: 35,
    fields: ["FeatureNo"],
    searchType: "LIKE",
    displayField: "FEATURENO",
  },
  {
    name: "Map Sheet",
    type: "textualSearchLayer",
    inputType: "slopeno",
    slopePart2List: ["NE", "NW", "SE", "SW"],
    slopePart3List: Array.apply(null, Array(25)).map((i, j) => j + 1),
    slopePart4List: "ABCD".split(""),
    noSlopeTextbox: true,
    layerId: 33,
    fields: ["MAP"],
    searchType: "EXACT",
  },
  {
    name: "Mitigated Hillside (MH) Features",
    type: "textualSearchLayer",
    inputType: "slopeno",
    slopePart3List: ["MH"],
    layerId: 44,
    fields: ["SLOPE_NO"],
    searchType: "EXACT",
  },
  {
    name: "NT Exempted House",
    type: "textualSearchLayer",
    layerId: 36,
    fields: ["REF"],
    searchType: "LIKE",
  },
  {
    name: "NTHS (District)",
    type: "textualSearchLayer",
    layerId: 37,
    fields: ["REF"],
    searchType: "LIKE",
  },
  {
    name: "Registered Squatter Dwelling - with CAF in force",
    type: "textualSearchLayer",
    layerId: 47,
    fields: ["GEO_NDC_Dw"],
    searchType: "LIKE",
  },
  {
    name: "Tension Crack (Known)",
    type: "textualSearchLayer",
    layerId: 38,
    searchExample: "Tension Crack ID",
    fields: ["KTC_ID"],
    searchType: "LIKE",
    searchExample2: "Location",
    fields2: ["LOCATION"],
    searchType2: "LIKE",
    resultItemFormatter: (row) => `${row.KTC_ID} - ${row.LOCATION}`,
  },
  {
    name: "Tunnel Submission Records",
    type: "textualSearchLayer",
    layerId: 39,
    fields: [
      "PROJECT_TITLE",
      "AGREEMENT_TITLE",
      "GEO_ENGINEER",
      "DOCUMENT_TITLE",
      "DOCUMENT_NO",
      "DOCUMENT_KEYWORD",
    ],
    searchType: "LIKE",
  },
  {
    name: "Unauthorized Slope Works",
    type: "textualSearchLayer",
    layerId: 40,
    fields: ["TAGMARK"],
    searchType: "LIKE",
  },
];
